
        var result = require("!!../../../node_modules/css-loader/index.js!./no-content.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/no-content/no-content.component.css
// module id = 1034
// module chunks = 73